export default __webpack_public_path__ + "static/media/NAUBusiness.2d673165.svg";